import Container from 'react-bootstrap/Container'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import NavDropdown from 'react-bootstrap/NavDropdown'
import { Link, Outlet, useNavigate } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'
import { useCapabilities } from '../hooks/useCapabilities'
import { ThemeToggle } from './ThemeToggle'

export function AppLayout() {
    const { user, logout } = useAuth()
    const navigate = useNavigate()

    const handleLogout = async () => {
        await logout()
        navigate('/prihlaseni', { replace: true })
    }

    return (
        <div className="su-app">
            <Navbar bg="primary" variant="dark" expand="sm" sticky="top">
                <Container>
                    <Navbar.Brand as={Link} to="/">
                        <i className="bi bi-people-fill me-2" aria-hidden="true" />
                        SplitUp
                    </Navbar.Brand>

                    {/* Přepínač motivu je dostupný i bez přihlášení; na širokém displeji patří až za menu. */}
                    <div className="d-flex align-items-center order-sm-last">
                        <ThemeToggle />
                        {user && <Navbar.Toggle aria-controls="hlavni-menu" label="Hlavní menu" data-testid="hlavni-menu-toggle" />}
                    </div>

                    {user && (
                        <Navbar.Collapse id="hlavni-menu">
                            <Nav className="me-auto">
                                <Nav.Link as={Link} to="/">
                                    Skupiny
                                </Nav.Link>
                                {user.isAdmin && (
                                    <Nav.Link as={Link} to="/sprava/uzivatele">
                                        Uživatelé
                                    </Nav.Link>
                                )}
                            </Nav>
                            <Nav>
                                <NavDropdown title={user.displayName} align="end" id="uzivatelske-menu" data-testid="uzivatelske-menu">
                                    <NavDropdown.Item as={Link} to="/platebni-udaje">
                                        Platební údaje
                                    </NavDropdown.Item>
                                    <PolozkaAsistenta />
                                    <NavDropdown.Item as={Link} to="/zmena-hesla">
                                        Změnit heslo
                                    </NavDropdown.Item>
                                    <NavDropdown.Divider />
                                    <NavDropdown.Item onClick={() => void handleLogout()}>Odhlásit se</NavDropdown.Item>
                                </NavDropdown>
                            </Nav>
                        </Navbar.Collapse>
                    )}
                </Container>
            </Navbar>

            <main className="su-content">
                <Container className="py-3">
                    <Outlet />
                </Container>
            </main>
        </div>
    )
}

/**
 * Odkaz na přístup pro AI asistenta. Je ve vlastní komponentě, aby se
 * schopnosti instalace načítaly jen u přihlášeného uživatele.
 */
function PolozkaAsistenta() {
    const { data: capabilities } = useCapabilities()
    if (!capabilities?.receiptMcp) {
        return null
    }
    return (
        <NavDropdown.Item as={Link} to="/ai-asistent">
            AI asistent (MCP)
        </NavDropdown.Item>
    )
}
